import * as React from 'react';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar, { MenuGroup } from "../../../Sidebar";
import ModalContainer from "../../../Modals/components/ModalContainer";
import { NotificationsContainer } from "../../../Notifications";
import ScrollToTop from "../ScrollToTop";
import style from './Content.scss';

export type RouteItem = {
  path: string,
  name: string,
  component: () => Promise<{ default: React.ComponentType | React.FunctionComponent }>,
}

export type Props = {
  defaultRouteUrl?: string,
  renderRouter: (renderer: () => JSX.Element) => JSX.Element,
  menu?: MenuGroup[],
  renderSidebarFooter?: () => React.ReactNode,
  getSidebarContext?: () => object,

};

const Content: React.FC<Props> = (props) => {
  const { defaultRouteUrl, renderRouter, menu, renderSidebarFooter, getSidebarContext } = props
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.pathname === '/' && defaultRouteUrl) navigate(defaultRouteUrl, { replace: true });
  }, [location]);

  const renderLocalRouter = React.useCallback(() => {
    return <Outlet />
  }, []);

  return (
    <>
      {menu && <Sidebar menu={menu} renderFooter={renderSidebarFooter} getContext={getSidebarContext} />}
      <main className={style.container}>
        {renderRouter(renderLocalRouter)}
      </main>

      <ModalContainer />
      <NotificationsContainer />
      <ScrollToTop />
    </>
  );
}

export default Content;
